
import { Component, Prop, Vue } from 'vue-property-decorator'
import Actions from '@/components/bis_list/actions.vue'
import BIS from '@/components/bis_list/bis.vue'
import Current from '@/components/bis_list/current.vue'
import Details from '@/components/bis_list/details.vue'
import Filters from '@/components/bis_list/filters.vue'
import BISListModify from '@/dataclasses/bis_list_modify'
import { CharacterDetails } from '@/interfaces/character'
import { BISListErrors } from '@/interfaces/responses'

@Component({
  components: {
    Actions,
    BIS,
    Current,
    Details,
    Filters,
  },
})
export default class BISListDesktopForm extends Vue {
  @Prop()
  bisList!: BISListModify

  @Prop()
  character!: CharacterDetails

  @Prop()
  charIsProxy!: boolean

  @Prop()
  displayOffhand!: boolean

  @Prop()
  errors!: BISListErrors

  @Prop()
  etroImportable!: boolean

  @Prop()
  importLoading!: boolean

  // Set up default values for min and max IL, will change as new tiers are released
  @Prop()
  maxIl!: number

  @Prop()
  method!: string

  @Prop()
  minIl!: number

  @Prop()
  syncable!: boolean

  @Prop()
  url!: string

  @Prop()
  xivGearImportable!: boolean

  importEtroBis(): void {
    this.$emit('import-etro-bis-data')
  }

  importFromOtherList(): void {
    this.$emit('import-current-data')
  }

  importLodestone(): void {
    this.$emit('import-current-lodestone-gear')
  }

  importXIVGearBis(): void {
    this.$emit('import-xivgear-bis-data')
  }
}
